import { HTMLAttributes } from 'react';

import { FontItalicIcon } from '@radix-ui/react-icons';
import { useEditorState, type Editor } from '@tiptap/react';

import { Toggle } from '../../../primitives/toggle';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../primitives/tooltip';

interface ToggleItalicProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  editor: Editor;
}

export function ToggleItalic({ className, editor }: ToggleItalicProps) {
  const { isItalic } = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      isItalic: editor.isActive('italic'),
    }),
  });

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <Toggle
            aria-label="Cursiva"
            className={className}
            disabled={!editor.isEditable}
            pressed={isItalic}
            size="icon"
            variant="ghost"
            onPressedChange={() => editor.chain().focus().toggleItalic().run()}
          >
            <FontItalicIcon className="size-4" />
          </Toggle>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="flex flex-col">
          Cursiva <span className="text-accent">⌘I</span>
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
